module.exports = __webpack_public_path__ + "static/media/squared.05bffa26.jpg";